if(1 === 0) {
    var lang = 'pl';

    function interactiveMapGetInfo(kod) {

        var imgs = {
            'anwil': 'anwil',
            'orlen lietuva': 'orlen_lietuva',
            'spolana': 'spolana',
            'paramo': 'paramo',
            'orlen oil': 'orlen_oil',
            'orlen asfalt': 'orlen_asfalt',
            'pkn orlen': 'pkn_orlen',
            'orlen poludnie': 'orlen_poludnie',
            'iks solino': 'iks_solino',
            'orlen deutschland': 'orlen_deutschland',
            'orlen paliwa': 'orlen_paliwa',
            'orlen upstream': 'orlen_upstream',
            'unipetrol rpa': 'unipetrol',
            'unipetrol': 'unipetrol'
        };

        var map = function (array, func) {
            var result = [];
            for (var index in array) {
                result.push(func(array[index]));
            }
            return result;
        }

        var url = '/assets/data/interactive_map/' + lang + '/' + kod + '.json';
        $.ajax({
            url: url,
        })
            .done(function (data) {
                if (data && typeof data === 'object') {
                    $('.map-legend').find('.rb_title').html(data.kraj);
                    $('.map-legend').find('.scroll').find('ul').html(map(data.produkty, function (p) {
                        return '<li>' + p + '</li>';
                    }));
                    $('.spolki_logotypy').html("<script>jQuery(function(){var orlenGroupSwiper = new Swiper('.map_spolki .swiper-container', {      speed: 800,      ppagination: false,   autoplay: {delay: 1000},   slidesPerView: 'auto',      loop:false,      spaceBetween: 0  }); });<\/script><div class=\"swiper-container\"><div class=\"swiper-wrapper\">" +
                        map(data.spolki, function (s) {
                            return imgs[s.trim().toLowerCase()] ? '<div class=\"col-lg-3 col-md-6 col-xs-12 col-xl-20 swiper-slide\"><img src=\"\/assets\/page\/interactive_map\/spolki\/' + imgs[s.trim().toLowerCase()] + '.png\"></div>' : console.log(s.trim().toLowerCase());
                        }).join('') + "<\/div><\/div><\/div>").fadeIn();
                    mapLegendOpen();
                }
            });
    }

    function mapLegendClose() {
        $('.map-legend').fadeOut();
    }

    function mapLegendOpen() {
        $('.map-legend').fadeIn();
    }

    jQuery(function () {
        $('.scrollbar-rail').scrollbar();
        $('div.mapa').css('height', ($(window).height() - 170) + 'px');
        $('#map1').vectorMap({

            map: 'world_mill_pl',
            panOnDrag: true,
            markers: [{
                latLng: [30, -150],
                name: 'SprzedaĹź morska'
            },
                {
                    latLng: [30, -45],
                    name: 'SprzedaĹź morska'
                },
                {
                    latLng: [-15, 76],
                    name: 'SprzedaĹź morska'
                },
                {
                    latLng: [52.5, 17.5],
                    name: 'Stacje paliw'
                }, //PL
                {
                    latLng: [52.5, 19.1],
                    name: 'Aktywa wydobywcze'
                }, //PL
                {
                    latLng: [52.5, 20.67],
                    name: 'Aktywa rafineryjne'
                }, //PL
                {
                    latLng: [51.5, 18.33],
                    name: 'Aktywa petrochemiczne'
                }, //PL
                {
                    latLng: [51.5, 20],
                    name: 'Aktywa energetyczne'
                }, //PL
                {
                    latLng: [51.0, 10.5],
                    name: 'Stacje paliw'
                }, //DE
                {
                    latLng: [50.5, 13.5],
                    name: 'Stacje paliw'
                }, //CZ
                {
                    latLng: [50.5, 15],
                    name: 'Aktywa rafineryjne'
                }, //CZ
                {
                    latLng: [49.65, 14.25],
                    name: 'Aktywa petrochemiczne'
                }, //CZ
                {
                    latLng: [49.65, 15.7],
                    name: 'Aktywa energetyczne'
                }, //CZ
                {
                    latLng: [55.5, 23.5],
                    name: 'Stacje paliw'
                }, //LT
                {
                    latLng: [55.5, 25],
                    name: 'Aktywa rafineryjne'
                }, //LT
                {
                    latLng: [54.6, 24.25],
                    name: 'Aktywa energetyczne'
                }, //LT
                {
                    latLng: [60, -110],
                    name: 'Aktywa wydobywcze'
                }, //CA
                {
                    latLng: [49, 20.1],
                    name: 'Stacje paliw'
                }, //SK
            ],
            onMarkerOver: function (e, el, code) {
            },

            focusOn: {
                x: 0.5,
                y: 0.5,
                scale: 1,
                animate: true
            },
            onMarkerClick: function (event, label, index) {
                mapLegendClose();
                if (label < 3) {
                    interactiveMapGetInfo('M');
                }
            },
            onRegionClick: function (event, label, index) {
                mapLegendClose();
                interactiveMapGetInfo(label);
            },
            series: {
                markers: [{
                    attribute: 'fill',
                    scale: ['#345', '#678'],
                },
                    {
                        attribute: 'image',
                        scale: {
                            statek: '/assets/page/interactive_map/assets/statek_on.png', //statek.svg',
                            stacje: '/assets/page/interactive_map/assets/stacje.png',
                            stacje_sk: '/assets/page/interactive_map/assets/stacje_sk.png',
                            wydobywcze: '/assets/page/interactive_map/assets/wydobywcze.png',
                            wydobywcze_ca: '/assets/page/interactive_map/assets/wydobywcze_ca.png',
                            rafineryjne: '/assets/page/interactive_map/assets/rafineryjne.png',
                            petrochemiczne: '/assets/page/interactive_map/assets/petrochemiczne.png',
                            energetyczne: '/assets/page/interactive_map/assets/energetyczne.png',
                        },
                        values: {
                            '0': 'statek',
                            '1': 'statek',
                            '2': 'statek',
                            '3': 'stacje', //PL
                            '4': 'wydobywcze', //PL
                            '5': 'rafineryjne', //PL
                            '6': 'petrochemiczne', //PL
                            '7': 'energetyczne', //PL
                            '8': 'stacje', //DE
                            '9': 'stacje', //CZ
                            '10': 'rafineryjne', //CZ
                            '11': 'petrochemiczne', //CZ
                            '12': 'energetyczne', //CZ
                            '13': 'stacje', //LT
                            '14': 'rafineryjne', //LT
                            '15': 'energetyczne', //LT
                            '16': 'wydobywcze_ca', //CA
                            '17': 'stacje_sk', //SK
                        },
                    }
                ],
                regions: [{
                    scale: {
                        red: '#c0c0c0',
                        main: '/assets/page/interactive_map/assets/glowne.jpg'
                    },
                    attribute: 'fill',
                    values: {
                        "AB": 'red',
                        "AF": 'red',
                        "AL": 'red',
                        "AM": 'red',
                        "AT": 'red',
                        "AU": 'red',
                        "AW": 'red',
                        "AZ": 'red',
                        "BA": 'red',
                        "BE": 'red',
                        "BF": 'red',
                        "BG": 'red',
                        "BO": 'red',
                        "BR": 'red',
                        "BS": 'red',
                        "BY": 'red',
                        "CA": 'red',
                        "CH": 'red',
                        "CL": 'red',
                        "CN": 'red',
                        "CO": 'red',
                        "CY": 'red',
                        "CZ": 'main',
                        "DE": 'main',
                        "DK": 'red',
                        "DO": 'red',
                        "DZ": 'red',
                        "EC": 'red',
                        "EE": 'red',
                        "ES": 'red',
                        "ET": 'red',
                        "FI": 'red',
                        "FR": 'red',
                        "GB": 'red',
                        "GD": 'red',
                        "GE": 'red',
                        "GH": 'red',
                        "GQ": 'red',
                        "GR": 'red',
                        "GY": 'red',
                        "HR": 'red',
                        "HU": 'red',
                        "IE": 'red',
                        "IL": 'red',
                        "IN": 'red',
                        "IQ": 'red',
                        "IR": 'red',
                        "IT": 'red',
                        "JO": 'red',
                        "KE": 'red',
                        "KR": 'red',
                        "KZ": 'red',
                        "LB": 'red',
                        "LK": 'red',
                        "LT": 'main',
                        "LU": 'red',
                        "LV": 'red',
                        "MD": 'red',
                        "ME": 'red',
                        "MH": 'red',
                        "MK": 'red',
                        "MN": 'red',
                        "MR": 'red',
                        "MT": 'red',
                        "MW": 'red',
                        "MX": 'red',
                        "MY": 'red',
                        "NC": 'red',
                        "NL": 'red',
                        "NO": 'red',
                        "NZ": 'red',
                        "OM": 'red',
                        "PE": 'red',
                        "PF": 'red',
                        "PH": 'red',
                        "PK": 'red',
                        "PL": 'main',
                        "PT": 'red',
                        "PY": 'red',
                        "RO": 'red',
                        "RS": 'red',
                        "RU": 'red',
                        "SV": 'red',
                        "SC": 'red',
                        "SE": 'red',
                        "SI": 'red',
                        "SK": 'red',
                        "SM": 'red',
                        "SN": 'red',
                        "ST": 'red',
                        "TG": 'red',
                        "TJ": 'red',
                        "TR": 'red',
                        "TW": 'red',
                        "TZ": 'red',
                        "UA": 'red',
                        "UG": 'red',
                        "US": 'red',
                        "UY": 'red',
                        "UZ": 'red',
                        "VI": 'red',
                        "XK": 'red',
                        "BB": 'red',
                        "VI": 'red'
                    }
                }]
            }
        });
    })
}

